var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.rowData.status === 0
    ? _c("span", { staticClass: "created" }, [_vm._v("Draft")])
    : _vm.rowData.status === 1
    ? _c("span", { staticClass: "created" }, [_vm._v("Pending")])
    : _c("span", { staticClass: "created" }, [_vm._v(_vm._s(_vm.date))])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }